import type {
  CardProps as ChakraCardProps,
  ThemingProps,
} from '@chakra-ui/react';
import { Card as ChakraCard } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export interface CardProps
  extends OmitChakraProps<ChakraCardProps, keyof ThemingProps> {
  isDivided?: boolean;
  variant?: 'outline' | 'unstyled' | 'filled' | 'control';
}

export const Card = withChakraAs<CardProps, 'div'>(
  ({ isDivided, ...props }) => {
    return <ChakraCard data-is-divided={isDivided} {...props} />;
  },
);
